module.exports = __webpack_public_path__ + "static/media/pagamentos.b385af24.png";